export const permitStatus = {
  PENDING: "pending",
  ACTIVATED: "activated",
  EXPIRED: "expired",
  CANCELLED: "cancelled",
};
